import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITokenService, SERVICE_TOKEN } from './core/api/token/interface';
import { NativeService } from './core/native/native.service';

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Co-Nurse 看護師アプリ';

  private tokenChangeSub: Subscription = new Subscription();

  constructor(
    @Inject(SERVICE_TOKEN) private tokenService: ITokenService,
    private nativeService: NativeService,
  ) {}

  ngOnInit(): void {
    // トークンの変更を監視し、AndroidのSharedPreferencesに同期する
    this.tokenChangeSub = this.tokenService.change().subscribe(token => {
      if (token?.accessToken) {
        this.nativeService.syncToken(token.accessToken);
      } else {
        // ログアウト時はSharedPreferencesからトークンを削除する
        this.nativeService.clearToken();
      }
    });
  }

  ngOnDestroy(): void {
    this.tokenChangeSub.unsubscribe();
  }
}
